<template>
    <div class="mx-auto">
        <div class="col-12 mb-3">
            <label class="font-weight-bold">{{ $t('planning.year') }}</label>
            <select class="form-control" v-model="selectedYear">
                <option v-for="(year, index) in years" :key="index" :value="year" :selected="year == currentYear">{{ year }}</option>
            </select>
        </div>
        <div class="card mt-2 px-0">
            <div class="card-header bg-primary text-white">
                <div class="card-title h5 m-0">
                    {{ $t('organizationalProposals.title') }}
                </div>
            </div>
            <div class="card-body">
                <kendo-datasource ref="gridDataSource"
                                  :transport="transportSettings"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'count'"
                                  :schema-data="'items'"
                                  :page-size='defaultGridRows'
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError">
                </kendo-datasource>
                <kendo-grid ref="grid"
                            :height="600"
                            :data-source-ref="'gridDataSource'"
                            :editable="gridOptions.editable"
                            :filterable="gridOptions.filterable"
                            :pageable="gridOptions.pageable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="gridOptions.groupable"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable"
                            :dataBound="dataBound">
                    <kendo-grid-column :field="'proposal'"
                                       :title="$t('organizationalProposals.proposal')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'proposedBy'"
                                       :title="$t('organizationalProposals.proposedBy')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'date'"
                                       :format="customDateTimeFormat"
                                       :title="$t('organizationalProposals.date')">
                    </kendo-grid-column>
                    <!-- TODO: Формуляр от който идва -->
<!--                    <kendo-grid-column :template="btnsTemplate"
                                       field="btnsColumn"
                                       :title="' '"
                                       v-if="showBtns">
                    </kendo-grid-column>-->
                </kendo-grid>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import store from '../../store/store';

    export default {
        data() {
            return {
                years: [],
                selectedYear: new Date().getFullYear(),
                currentYear: new Date().getFullYear(),
                defaultGridRows: this.$store.getters.defaultGridRows,
                schemaModelFields: {
                    // id: { name: 'id', type: 'number', editable: false, nullable: true, visible: true, titleKey: 'activity.id' },
                    proposal: { name: 'proposal', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'organizationalProposals.proposal' },
                    proposedBy: { name: 'proposedBy', type: 'string', editable: false, nullable: true, visible: true, titleKey: 'organizationalProposals.proposedBy' },
                    // proposedById
                    date: { name: 'date', type: 'date', editable: false, nullable: true, visible: true, titleKey: 'organizationalProposals.date' }
                },
                transportSettings: {
                    read: {
                        url: `${store.getters.baseUrl}/api/OrganizationalProposal/list`,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
            }
        },
        methods: {
            loadYears() {
                let currentYear = this.currentYear;
                const years = 50;
                for (let i = currentYear - years; i <= currentYear + years; i++) {
                    this.years.push(i);
                }
            },
            beforeSend(req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            parameterMap(options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    this.saveState();
                    let newOptions = { year: this.selectedYear, request: options }
                    return kendo.stringify(newOptions);
                }
            },
            saveState: function () {
                let grid = this.$refs.grid.kendoWidget();

                localStorage["audit-grid-options"] = kendo.stringify(grid.getOptions());
            },
            loadState: function () {
                let options = localStorage["kendo-grid-options"];
                let grid = this.$refs.grid.kendoWidget();

                if (options) {
                    grid.setOptions(JSON.parse(options));
                }
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            dataBound(e) {
                // TODO: this.loadColumnsVisibilitySettings();
            }
        },
        computed: {
            ...mapGetters(['gridOptions', 'claims', 'dateTimeFormat']),
            token: function () {
                return store.getters.authToken;
            },
            customDateTimeFormat() {
                return `{0:${this.dateTimeFormat}}`
            }
        },
        watch: {
            selectedYear: function (newVal, oldVal) {
                const grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    grid.dataSource.read();
                }
            }
        },
        mounted () {
            this.loadYears();
        }
    }
</script>
